/* eslint-disable no-unused-vars */
// import deviceDetector from '@/services/device-detector'
// import Cookies from '@/services/cookies'

/** @constant
 * @description начало названия куки для аб теста (для удобного поиска в браузере и отделения кук для теста от остальных)
  @type {string}
  @default empty
*/
const globalPrefix = 'gfab_'

/**
 * значение куки пустого теста.
 * @typedef {string} EmptyTestKey
  @default empty
 */

/** @constant
 * значение куки пустого теста.
  @type {EmptyTestKey}
*/
const emptyTestKey = 'empty'

/**
 * Возвращает объект для создания аб тестов
 * @module abtesting\config
 *
 * @example
 * // Calls the `hide` function when the ESC key is pressed down
 * useKeyDown(27, hide)
 * @exports module:abtesting
 */

/**
 * Вариация для аб-теста
 * @typedef {Object} VariationsOfAbTest
 * @property {string|EmptyTestKey} key - значение для записи в куки (либо строка, либо emptyTestKey)
 * @property {number} probability - распределение групп в процентов соотношении от 0 до 1 (в сумме всех вариаций одного теста должна быть единица).
 * @property {function():object} execute возвращает объект с ключами и значениями для проставления в геттеры, они получаются в зависимости от текущих активных тестов через getters('abtesting/variationActionsDomain')
 */

/**
 * АБ тест
 * @typedef {Object} AbTest
 * @property {string} name - название аб теста (записывается в куки). состоит из globalPrefix + 'название_теста'.
 * @property {number} cookieExpirationDays=30 - срок записи для кук
 * @property {function((object:{rootGetters})):boolean} needRunTest - функция которая определяет необходимость запуска аб теста <br>
 * // 'new', 'unauthorized', 'old', 'active'
 * // rootGetters['client/profile'].activity_status
 * // rootGetters['marketing/activityStatusForPromotion']
 * // return ['unauthorized', 'new'].includes(rootGetters['client/profile'].activity_status) // aб для незарегов и новых
 * // return deviceDetector.isSmartphone // aб для смартфонов
 * @property {VariationsOfAbTest[]} variations - список вариаций теста
 * @example
 * // {
 * //   name: globalPrefix + 'ninja',
 * //   gaDimensionIndex: 15,
 * //   cookieExpirationDays: 30,
 * //   needRunTest: ({ rootGetters }) => {
 * //     const realStatus = rootGetters['client/profile']?.activity_status || 'unauthorized'
 * //     return ['unauthorized', 'new'].includes(realStatus)
 * //   },
 * //   variations: [
 * //     {
 * //       key: 'ninja',
 * //       probability: 0.5,
 * //       execute () {
 * //         return {
 * //           ninja: true
 * //         }
 * //       }
 * //     },
 * //     {
 * //       key: emptyTestKey,
 * //       probability: 0.5,
 * //       execute () {
 * //         return {
 * //           ninja: false
 * //         }
 * //       }
 * //     }
 * //   ]
 * // },
 */

export default {
  emptyTestKey: emptyTestKey,
  /**
   * Список аб-тестов для проверки или запуска.
   * @type {AbTest[]}
   */
  tests: [
  ],
}
